import { GetTradeDetailsResp } from '#/unified-rfqs/repositories/grfq-types';
import { Resp } from '@paradigm/api/src/fetch-api';

export function errorMessageView(rfqResp: Resp<GetTradeDetailsResp> | null) {
  return rfqResp?.ok === false ? rfqResp.message : '';
}
